<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-12">
                    <div class="p-2">
                        <h5 v-if="transactionType === 'payment' && activePayment.outSourceName !== ''"
                            class="text-center mb-0">پرداخت به <b
                                class="text-success">{{activePayment.outSourceName}} ({{ transactionType === 'payment' ?
                            toTitle :
                            fromTitle}})</b> از</h5>
                        <h5 v-if="transactionType === 'receive' && activePayment.outSourceName !== ''"
                            class="text-center mb-0">دریافت از <b
                                class="text-success">{{activePayment.outSourceName}} ({{ transactionType === 'receive' ?
                            fromTitle :
                            toTitle}})</b> به</h5>
                    </div>
                </div>
                <!--<div class="col-12 col-md-4 col-lg-6 text-left">
                    <button class="btn btn-success mr-2" @click="onTransactionSubmitClicked">ثبت تراکنش</button>
                </div>-->

            </div>
        </div>
        <div class="row mt-3">
            <div class="col-lg-4">
                <div class="card archive radius" id="bank">
                    <div class="card-header headline bank glow-danger radius">
                        <h2 class="text-center text-white">بانک</h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 mb-3 product-container" v-for="(item, index) in banks">
                                <div class="card shadow pt-2 pb-2 payment"
                                     @click="onCardClicked($event, index, 'bank')">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.outSourceName}}</h5>
                                            <h6 class="text-center">{{item.accountNumber}}</h6>
                                            <h6 class="text-center"> موجودی : {{item.remain.toLocaleString()}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="sk-circle" id="loading-bank">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card archive radius" id="cashDesk">
                    <div class="card-header headline cash-desk glow-success radius">
                        <h2 class="text-center text-white">صندوق</h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 mb-3 product-container" v-for="(item, index) in cashDesks">
                                <div class="card shadow pt-2 pb-2 payment"
                                     @click="onCardClicked($event, index, 'cashDesk')">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.outSourceName}}</h5>
                                            <h6 class="text-center"> موجودی : {{item.remain.toLocaleString()}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="sk-circle" id="loading-cash-desk">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card archive radius" id="checkBook">
                    <div class="card-header headline check-book glow-info radius">
                        <h2 class="text-center text-white">چک</h2>
                    </div>
                    <div class="card-body">
                        <div class="row" v-if="transactionType === 'payment'">
                            <div class="col-lg-12 mb-3 product-container" v-for="(item, index) in checkBooks">
                                <div class="card shadow pt-2 pb-2 payment"
                                     @click="onCardClicked($event, index, 'checkBook')">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.outSourceName}}</h5>
                                            <span>مبلغ: </span>
                                            <span>{{item.price.toLocaleString()}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-lg-12 mb-3 product-container" v-for="(item, index) in customerChecks">
                                <div class="card shadow pt-2 pb-2 payment">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.check.bankName}}</h5>
                                            <span>مبلغ: </span>
                                            <span>{{item.price.toLocaleString()}}</span>
                                            <br>
                                            <span>تاریخ چک: </span>
                                            <span>{{item.check.checkPersianDate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 text-center mt-5">
                                <button class="btn btn-primary" data-toggle="modal" data-target="#check">افزودن چک
                                </button>
                            </div>
                            <div class="col-lg-12">
                                <div class="sk-circle" id="loading-check-book">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="payment" tabindex="-1" role="dialog" aria-labelledby="paymentTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 v-if="transactionType === 'payment'" class="modal-title text-white">پرداخت به <span>{{activePayment.outSourceName}}</span>
                                از <span>{{activePayment.name}}</span></h5>
                            <h5 v-if="transactionType === 'receive'" class="modal-title text-white">دریافت از <span>{{activePayment.outSourceName}}</span>
                                به <span>{{activePayment.name}}</span></h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-6 offset-lg-3 text-center">
                                    <div class="input-group m-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">مبلغ</span>
                                        </div>
                                        <input class="form-control" type="number" v-model="activePayment.price" @input="thousandSeprator(activePayment.price)">
                                    </div>
                                    <small class="text-nowrap mt-2">{{activePayment.priceShow}}</small>
                                    <!--<div class="input-group m-2">-->
                                    <!--<div class="input-group-prepend">-->
                                    <!--<span class="input-group-text">توضیحات</span>-->
                                    <!--</div>-->
                                    <!--<input class="form-control" v-model="activePayment.description">-->
                                    <!--</div>-->
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-success" @click="onPaymentModalOk">ثبت</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="check" tabindex="-1" role="dialog" aria-labelledby="checkTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-info-grad glow-info">
                            <h5 class="modal-title text-white" id="checkTitle">ایجاد چک جدید</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-6 mb-2" v-if="transactionType === 'payment'">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">دسته چک بانک</span>
                                        </div>
                                        <vs-select :data="banks" :mode="'create'"
                                                   :header="{multiple: false, label: 'outSourceName'}"
                                                   @onChange="onBankChange2"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2" v-if="transactionType === 'receive'">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام بانک</span>
                                        </div>
                                        <vs-select :data="bankList" :mode="'create'"
                                                   :header="{multiple: false, label: 'name'}"
                                                   @onChange="onBankChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2" v-if="transactionType === 'receive'">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام شعبه</span>
                                        </div>
                                        <input class="form-control" type="text"
                                               v-model="activePayment.check.branchName">
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2" v-if="transactionType === 'receive'">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">کد شعبه</span>
                                        </div>
                                        <input class="form-control" type="number"
                                               v-model="activePayment.check.branchCode">
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">شماره چک</span>
                                        </div>
                                        <input class="form-control" type="number"
                                               v-model="activePayment.check.checkNumber">
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group mb-2">
                                        <div class="input-group-prepend" @click="toggleDatePicker">
                                            <div class="input-group-text"><span>تاریخ چک</span></div>
                                        </div>
                                        <date-picker type="date" format="jYYYY-jMM-jDD" :auto-submit="true" @input="onDatePicked"
                                                     ref="datePicker" style="flex: 1">
                                            <slot>
                                                <input v-model="activePayment.check.checkPersianDate"
                                                       class="form-control date-input" @click="toggleDatePicker">
                                                <button class="close reset-date" @click="resetDate">×</button>
                                            </slot>
                                        </date-picker>
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2 text-center">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">مبلغ</span>
                                        </div>
                                        <input class="form-control" type="number" v-model="activePayment.price" @input="thousandSeprator(activePayment.price)">
                                    </div>
                                    <small class="text-nowrap mt-2">{{activePayment.priceShow}}</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-success" @click="onCheckModalOk">ثبت</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="customer" tabindex="-1" role="dialog" aria-labelledby="customerTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-danger-grad glow-danger">
                            <h5 class="modal-title text-white" id="customerTitle">لیست مشتریان</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-12 mt-5" v-if="customers.length < 1">
                                    <h3 class="text-center no-item-alert">مشتری ثبت نشده است!</h3>
                                </div>
                                <div class="col-lg-3 mb-3" v-for="(item, index) in customers">
                                    <div class="card shadow" @click="onCustomerClicked(index)">
                                        <div class="row p-2">
                                            <div class="col-lg-12">
                                                <h5 class="text-center">{{item.outSourceName}}</h5>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="sk-circle" id="loading-customer">
                                        <div class="sk-circle1 sk-child"></div>
                                        <div class="sk-circle2 sk-child"></div>
                                        <div class="sk-circle3 sk-child"></div>
                                        <div class="sk-circle4 sk-child"></div>
                                        <div class="sk-circle5 sk-child"></div>
                                        <div class="sk-circle6 sk-child"></div>
                                        <div class="sk-circle7 sk-child"></div>
                                        <div class="sk-circle8 sk-child"></div>
                                        <div class="sk-circle9 sk-child"></div>
                                        <div class="sk-circle10 sk-child"></div>
                                        <div class="sk-circle11 sk-child"></div>
                                        <div class="sk-circle12 sk-child"></div>
                                    </div>
                                </div>
                                <div v-if="customers.length > 17" class="col-lg-12 text-center mb-3"
                                     @click="getCustomers">
                                    <button class="btn btn-success">نمایش موارد بیشتر</button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="transaction" tabindex="-1" role="dialog" aria-labelledby="transactionTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-danger-grad glow-danger">
                            <h5 class="modal-title text-white" id="transactionTitle">خلاصه تراکنش</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="table-responsive modal-body" id="printMe">
                            <table class="table table-bordered">
                                <tbody>
                                <tr>
                                    <td>
                                        <strong>نوع تراکنش</strong>
                                    </td>
                                    <td>
                                        <span>{{transactionType === 'payment' ? 'پرداخت' : 'دریافت'}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{{transactionType === 'payment' ? 'پرداخت به' : 'دریافت از'}} ({{
                                            transactionType === 'payment' ? toTitle : fromTitle}})</strong>
                                    </td>
                                    <td>
                                        <span>{{activePayment.outSourceName}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{{transactionType === 'payment' ? 'برداشت از' : 'واریز به'}} ({{
                                            transactionType === 'payment' ? fromTitle : toTitle}})</strong>
                                    </td>
                                    <td>
                                        <span>{{activePayment.usedCheck ? 'چک' : activePayment.name}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>مبلغ</strong>
                                    </td>
                                    <td>
                                        <!--<span>{{activePayment.price.toLocaleString()}}</span>-->
                                        <span>{{thousandSepratorprint(activePayment.price)}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>توضیحات</strong>
                                    </td>
                                    <td>
                                        <!--<span>{{activePayment.price.toLocaleString()}}</span>-->
                                        <input class="form-control" type="text" v-model="activePayment.description">
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>تاریخ</strong>
                                    </td>
                                    <td>
                                        <div class="input-group mt-2">
                                            <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                                         ref="datePickerStart" style="flex: 1">
                                                <slot>
                                                    <input v-model="voucherDatePersian" class="form-control date-input" readonly="true"
                                                           @click="toggleStartDatePicker">
                                                    <button class="close reset-date" @click="resetStartDate">×</button>
                                                </slot>
                                            </date-picker>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                    class="fa fa-print"></i></button>
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary" @click="onConfirmationModalOk">تایید</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect"
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from 'moment-jalali';
    import VueHtmlToPaper from 'vue-html-to-paper';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'payment',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {

                banks: [],
                cashDesks: [],
                checkBooks: [],

                transactionType: "",
                remainingAmount: 0,

                activePayment: {
                    code: "",
                    price: 0,
                    name: "",
                    check: {
                        checkNumber: "",
                        checkDate: "",
                        checkPersianDate: "",
                        bankName: "",
                        branchName: "",
                        branchCode: ""
                    },
                    voucherDate: "0001-01-01",
                },

                hasCheck: false,
                archivedVoucher: false,
                customerChecks: [],

                payments: [],
                customers: [],


                queryParams: {
                    pageSize: 18,
                    pageIndex: 0,
                    types: 1
                },
                bankList: [
                    {name: "کشاورزی"},
                    {name: "انصار"},
                    {name: "آینده"},
                    {name: "بانک مرکزی"},
                    {name: "بانک شهر"},
                    {name: "دی"},
                    {name: "اقتصاد نوین"},
                    {name: "گردشگری"},
                    {name: "قوامین"},
                    {name: "کارافرین"},
                    {name: "مسکن"},
                    {name: "مهر"},
                    {name: "ملت"},
                    {name: "ملی"},
                    {name: "پارسیان"},
                    {name: "پاسارگاد"},
                    {name: "پست بانک"},
                    {name: "رفاه"},
                    {name: "رسالت"},
                    {name: "صادرات"},
                    {name: "صنعت و معدن"},
                    {name: "سرمایه"},
                    {name: "سپه"},
                    {name: "سینا"},
                    {name: "تجارت"},
                    {name: "سرمایه"},
                ],
                fromTitle: "",
                toTitle: "",
                isSending: false,

                voucherDatePersian: "",
            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            this.transactionType = this.$route.params.type;
            this.activePayment = this.$route.params.transaction;
            if (this.activePayment.fromCode !== "") {
                this.fromTitle = this.findCode(this.activePayment.fromCode);
            }
            if (this.activePayment.toCode !== "") {
                this.toTitle = this.findCode(this.activePayment.toCode);
            }
            Vue.set(this.activePayment, 'name', '');
            Vue.set(this.activePayment, 'usedCheck', false);

            this.queryParams.types = 1;
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.banks = response.data.data;
                $("#loading-bank").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });

            this.queryParams.types = 2;
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.cashDesks = response.data.data;
                $("#loading-cash-desk").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });

            this.queryParams.types = 12;
            this.queryParams.checkStatus = 0;
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.checkBooks = response.data.data;
                $("#loading-check-book").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });
            let tod = Moment(new Date()).format('YYYY-MM-DD');
            this.voucherDatePersian = Moment(tod, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
        },
        methods: {
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },

            findCode(mainText) {
                let code = mainText.substring(0, mainText.indexOf("9"));
                switch (parseInt(code)) {
                    case 1:
                        return "بانک";
                    case 2:
                        return "صندوق";
                    case 3:
                        return "مشتری";

                    case 5:
                        return "تامین کننده";
                    // case 6:
                    //    return "بانک";
                    case 7:
                        return "درآمد";
                    case 8:
                        return "هزینه";
                    // case 10:
                    //    return "بانک";
                    // case 11:
                    //    return "بانک";
                    // case 12:
                    //    return "بانک";
                    // case 13:
                    //    return "بانک";
                    case 14:
                        return "خرید آنلاین";
                }
            },
            onCardClicked(e, index, type) {
                this.activePayment.name = "";
                this.activePayment.code = "";
                this.activePayment.price = 0;
                if (type === 'bank') {
                    this.activePayment.name = this.banks[index].outSourceName;
                    this.activePayment.code = this.banks[index].code;
                    this.activePayment.usedCheck = false;
                    if (this.fromTitle === "") {
                        this.fromTitle = "بانک";
                    } else {
                        this.toTitle = "بانک";
                    }
                    $("#payment").modal("show");
                }
                if (type === 'cashDesk') {
                    this.activePayment.name = this.cashDesks[index].outSourceName;
                    this.activePayment.code = this.cashDesks[index].code;
                    this.activePayment.usedCheck = false;
                    if (this.fromTitle === "") {
                        this.fromTitle = "صندوق";
                    } else {
                        this.toTitle = "صندوق";
                    }
                    $("#payment").modal("show");
                }
                if (type === 'checkBook') {
                    this.activePayment.name = this.checkBooks[index].outSourceName;
                    this.activePayment.code = this.checkBooks[index].code;
                    this.activePayment.price = this.checkBooks[index].price;
                    this.activePayment.usedCheck = true;
                    if (this.fromTitle === "") {
                        this.fromTitle = "چک";
                    } else {
                        this.toTitle = "چک";
                    }
                    this.onPaymentModalOk();
                }
                /*for (let item of this.payments) {
                    if (item.code === this.activePayment.code) {
                        this.activePayment.price = item.price;
                    }
                }*/
            },
            /*onModalShow() {
                $("#voucherData").modal("show");
            },
            onModalEditClicked() {
                $("#voucherData").modal("hide");
                if (this.transactionType === "buy") {
                    let obj = {
                        name: 'buy-from-outsource',
                        params: {
                            id: this.voucher.serveOutSourceId,
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                } else {
                    let obj = {
                        name: 'sell',
                        params: {
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                }
            },*/
            onPaymentModalOk() {
                /*let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.price = parseInt(payment.price);
                //this.remainingAmount -= payment.price;
                //this.activePayment.price = parseInt(this.activePayment.price);
                if (this.payments.length < 1) {
                    this.payments.push(payment);
                } else {
                    let flag = false;
                    for (let item of this.payments) {
                        if (item.code === payment.code) {
                            item.price = payment.price;
                            flag = true;
                        }
                    }
                    if (flag === false) {
                        this.payments.push(payment);
                    }
                }
                this.activePayment.price = 0;
                $("#payment").modal("hide");*/
                $("#payment").modal('hide');
                $("#transaction").modal('show');

                /*if (this.activePayment.check.checkNumber === "") {
                    this.activePayment.check = null;
                }
                new BaseService('payment').create(this.activePayment).then(response => {
                    this.$noty.success("تراکنش با موفقیت ثبت شد!");
                    if (this.transactionType === 'payment') {
                        this.$router.push({name: 'payment-report'});
                    } else {
                        this.$router.push({name: 'receive-report'});
                    }

                    $("#payment").modal('hide');
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                })*/
            },
            onConfirmationModalOk() {
                if (this.activePayment.voucherDate === undefined || this.activePayment.voucherDate === null ||this.activePayment.voucherDate === "" || this.activePayment.voucherDate === "0001-01-01") {
                    this.activePayment.voucherDate =  Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.activePayment.voucherDate)) {
                    if (!this.isSending) {
                        this.isSending = true;
                        if (this.activePayment.check != null && this.activePayment.check !== undefined) {
                            if (this.activePayment.check.checkNumber === "") {
                                this.activePayment.check = null;
                            }
                        }
                        new BaseService('payment').create(this.activePayment).then(response => {
                            this.$noty.success("تراکنش با موفقیت ثبت شد.");
                            // if (this.activePayment.usedCheck === true) {
                            //     this.$router.push({name: 'check-book'});
                            // } else {
                            //     if (this.transactionType === 'payment') {
                            //         this.$router.push({name: 'home'});
                            //     } else {
                            //     }
                            // }
                            this.isSending = false;
                            $("#transaction").modal('hide');
                            this.$router.push({name: 'home'});

                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }
                }
            },
            onRemovePaymentClicked(index) {
                this.payments.splice(index, 1);
            },
            /*isActive(object) {
                for (let item of this.payments) {
                    if (item.code === object.code) {
                        return true;
                    }
                }
                return false;
            },*/
            onBankChange(val) {
                this.toTitle = "دریافت چک";
                this.activePayment.check.bankName = val.name;
                this.activePayment.check.rowVersion = this.generateUuid();
            },
            onBankChange2(val) {
                this.fromTitle = "دسته چک بانک " + val.outSourceName;
                // if (this.transactionType === 'payment') {
                this.activePayment.check.checkExporterBankId = val.id;
                this.activePayment.check.rowVersion = this.generateUuid();
                // } else {
                //     this.activePayment.check.checkExporterBankId = val.id;
                // }
            },
            toggleDatePicker() {
                this.$refs.datePicker.togglePicker();
            },
            onDatePicked(val) {
                this.activePayment.check.checkDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.activePayment.check.checkPersianDate = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetDate() {
                this.activePayment.check.checkPersianDate = '';
                this.activePayment.check.checkDate = '';
            },
            onCheckModalOk() {
                let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.price = parseInt(payment.price);
                this.payments.push(payment);
                if (this.transactionType === 'sell') {
                    this.hasCheck = true;
                }
                // this.customerChecks.push(payment);
                Utils.resetObject(this.activePayment.check);
                // this.activePayment.price = 0;
                this.activePayment.code = "";

                // let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.check.rowVersion = this.generateUuid();
                this.activePayment.usedCheck = true;
                this.activePayment.code = null;
                this.activePayment.check = payment.check;
                $("#check").modal('hide');
                this.onPaymentModalOk();
            },
            onTransactionSubmitClicked() {
                if (this.voucher.voucherDate === undefined || this.voucher.voucherDate === null ||this.voucher.voucherDate === "" || this.voucher.voucherDate === "0001-01-01") {
                    this.voucher.voucherDate =  Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.voucher.voucherDate)) {
                    if (!this.isSending) {
                        this.isSending = true;
                        if (isNaN(this.voucher.receiveOutSourceId)) {
                            this.voucher.receiveOutSourceId = "";
                        }
                        for (let item of this.payments) {
                            if (item.check.checkNumber === "") {
                                item.check = null;
                            }
                        }
                        new BaseService('voucher').create(this.voucher).then(response => {
                            let voucherId = response.data.data;
                            new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                                this.$noty.success("سند با موفقیت ثبت شد!");
                                if (this.archivedVoucher) {
                                    this.removeVoucherFromArchives(this.voucher.type, this.voucher.voucherIndex);
                                }
                                $("#customer").modal("hide");
                                this.$router.push({name: 'home'});
                            }).catch(error => {
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            })
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    }
                }
            },
            onCustomerAssignmentClicked() {
                if (this.remainingAmount < 0) {
                    this.$noty.error("مبلغ باقیمانده منفی میباشد!")
                } else {
                    this.queryParams.types = 1;
                    new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                        this.customers = response.data.data;
                        $("#loading-customer").hide();
                        $("#customer").modal("show");
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            onCustomerClicked(index) {
                this.voucher.receiveOutSourceId = this.customers[index].id;
                this.onVoucherSubmitClicked();
            },
            removeVoucherFromArchives(type, index) {
                if (type === 'buy') {
                    let archives = JSON.parse(localStorage.getItem("tempVoucherBuy"));
                    archives.splice(index, 1);
                    localStorage.setItem("tempVoucherBuy", JSON.stringify(archives));
                } else {
                    let archives = JSON.parse(localStorage.getItem("tempVoucherSell"));
                    archives.splice(index, 1);
                    localStorage.setItem("tempVoucherSell", JSON.stringify(archives));
                }
            },
            thousandSeprator(a) {

                let amount = a;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                this.activePayment.priceShow = showprice;

            },
            thousandSepratorprint(a) {

                let amount = a;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                return showprice;

            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            onStartDatePicked(val) {
                this.activePayment.voucherDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.voucherDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetStartDate() {
                this.activePayment.voucherDate = "0001-01-01";
                this.voucherDatePersian = '';
            },
        },
        // watch: {
        //     payments: {
        //         handler(val) {
        //             let sum = 0;
        //             for (let item of val) {
        //                 sum += item.price;
        //             }
        //             this.remainingAmount = this.voucher.overallPrice - sum;
        //         },
        //         deep: true
        //     }
        // },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#payment").hasClass("show")) {
                $("#payment").modal("hide");
                next(false);
            } else {
                if ($("#check").hasClass("show")) {
                    $("#check").modal("hide");
                    next(false);
                } else {
                    if ($("#customer").hasClass("show")) {
                        $("#customer").modal("hide");
                        next(false);
                    } else {
                        if ($("#transaction").hasClass("show")) {
                            $("#transaction").modal("hide");
                            next(false);
                        } else {
                            next();
                        }
                    }
                }
            }


        },
    }
</script>